import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AriaCheckedDirective } from 'src/app/accessibility/directives/aria-checked/aria-checked.directive';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { RvSpinnerDirective } from 'src/app/components/loading/rv-spinner.directive';
import { FeaturesService } from 'src/app/components/plans/features.service';
import { CapAlertsService } from 'src/app/settings/services/integrations/component-integrations/cap-alerts/cap-alerts.service';

@Component({
  selector: 'cap-alerts-enable-modal',
  templateUrl: './cap-alerts-enable-modal.component.html',
  styleUrl: './cap-alerts-enable-modal.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    AriaCheckedDirective,
    RvSpinnerDirective,
  ],
})
export class CapAlertsEnableModalComponent implements OnInit {
  featureAvailable: boolean | null = false;
  termsAccepted = false;

  constructor(
    public capAlertsService: CapAlertsService,
    private featuresService: FeaturesService,
    private userStateService: UserStateService,
    private dialogRef: MatDialogRef<CapAlertsEnableModalComponent>,
    private elementRef: ElementRef<HTMLElement>,
  ) {}

  get fieldsDisabled(): boolean {
    return (
      !this.featureAvailable ||
      !this.userStateService.hasPermission('ua') ||
      this.capAlertsService.isLoading
    );
  }

  get canSave(): boolean {
    return Boolean(
      this.termsAccepted &&
      this.featureAvailable &&
      !this.capAlertsService.isLoading &&
      !this.fieldsDisabled,
    );
  }

  ngOnInit(): void {
    this.capAlertsService.loadSettings();
    this.featureAvailable = this.featuresService.isFeatureAvailable(
      FeaturesService.FEATURE_ALERTS,
    );
    if (this.capAlertsService.alertSettings?.enabled) {
      this.termsAccepted = true;
    }
  }

  async saveAndContinue(): Promise<void> {
    if (!this.canSave) {
      return;
    }

    this.scrollDialogContentToTop();

    try {
      await this.capAlertsService.enable();
      if (this.capAlertsService.errorSaving) {
        this.scrollDialogContentToTop();
        return;
      }
      this.dialogRef.close(true);
    } catch {
      // errorSaving / apiError already set by CapAlertsService
      this.scrollDialogContentToTop();
    }
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  private scrollDialogContentToTop(): void {
    const content =
      this.elementRef.nativeElement.querySelector('mat-dialog-content');
    content?.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
